import ModeButton from "../common/ModeButton";
import { Mode } from "../types/Types";

interface ModeChoicesProps {
  mode: string;
  setMode: (mode: Mode) => void;
}

const ModeChoices: React.FC<ModeChoicesProps> = ({mode, setMode}) => {
  return (
    <>
      <div className='flex gap-3 font-extrabold text-secondary mt-20 mb-3 text-xl'>
        <ModeButton id='daily' title='Daily Challenge' mode={mode} setMode={setMode} />
      </div>

      <div className='flex gap-3 font-extrabold text-secondary text-xl'>
        <ModeButton id='small' title='Small' mode={mode} setMode={setMode} />
        <ModeButton id='medium' title='Medium' mode={mode} setMode={setMode} />
        <ModeButton id='large' title='Large' mode={mode} setMode={setMode} />
      </div>
    </>
  );
}
 
export default ModeChoices;
